export default [
  {
    "id": "first",
    "picture": "disons que c'est toi",
    "place": "1st",
    "like": 147,
    "color": "#90caf9",
  },
  {
    "id": "second",
    "picture": "disons que c'est peut etre toi",
    "place": "2nd",
    "like": 129,
    "color": "#ce93d8",
  },
  {
    "id": 3,
    "picture": "disons que c'est toiiiiii",
    "place": "3rd",
    "like": 95,
    "color": "#ffe082",
  },
  {
    "id": 4,
    "picture": "disons que c'est toi",
    "place": "4th",
    "like": 58,
    "color": "#f48fb1",
  },
  {
    "id": 5,
    "picture": "disons que c'est toi",
    "place": "5th",
    "like": 89,
    "color": "#c5e1a5",
  }
]
